module.exports = __webpack_public_path__ + "static/undraw_programming_2svr-403ee83f89a1977aaa6865a0331fc0ca.svg";